import { trackLead } from './metaPixel';
import { trackLead as trackTikTokLead } from './tiktokPixel';
import { buildSignupAttributionFragment } from './acquisitionAttribution';

const TRACKING_DEADLINE_MS = 750;
const POST_DISPATCH_DELAY_MS = 250;

export function navigateToSignupWithTracking() {
  const signupUrl = `/signup${buildSignupAttributionFragment()}`;
  const tracking = Promise.allSettled([trackLead(), trackTikTokLead()])
    .then(() => new Promise<void>((resolve) => {
      window.setTimeout(resolve, POST_DISPATCH_DELAY_MS);
    }));
  const deadline = new Promise<void>((resolve) => {
    window.setTimeout(resolve, TRACKING_DEADLINE_MS);
  });
  void Promise.race([tracking, deadline]).finally(() => window.location.assign(signupUrl));
}
